import { render, staticRenderFns } from "./dealer.vue?vue&type=template&id=c7e13416&scoped=true&"
import script from "./dealer.vue?vue&type=script&lang=js&"
export * from "./dealer.vue?vue&type=script&lang=js&"
import style0 from "./dealer.vue?vue&type=style&index=0&id=c7e13416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e13416",
  null
  
)

export default component.exports